import React, { useEffect, useState, Fragment } from 'react';
import { Button, Form, message, Avatar, Spin } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import './SurveyAnswer.less';
import Single from './topics/Single';
import Multiple from './topics/Multiple';
import MvpFill from './topics/MvpFill';
import Judge from './topics/Judge';
import Answer from './topics/Answer';
import MvpRegion from './topics/MvpRegion';
import logo from '../../../assets/img/survey_logo.png';
import { surveyResultApi, saveTrainSurveyApi, surveyDetailApi, templateDetailApi, beginAnswerApi, surveyInfoApi, trainingTaskStateApi } from '../api';
import { getCookie, getQueryString } from '../../../utils/utils';
import config from '../../../config';
import dayjs from 'dayjs';
import footerLogo from '../../../assets/img/footer_logo_black.png';

const SurveyAnswerMvp: React.FC = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [form] = Form.useForm();
    const [dataList, setDataList] = useState([]);
    const [name, setName] = useState('');
    const [directions, setDirections] = useState('');
    const [isMount, setIsMount] = useState(false);
    const [loading, setLoading] = useState(false);

    const sumit = () => {
        form.validateFields()
            .then(() => {
                save();
            })
            .catch(() => {
                message.error('请把必答题作答完成');
                console.log('提交失败');
            });
    };

    // 保存问卷答案
    const save = async () => {
        let paramApi: any = {
            answersheetId: localStorage.getItem('answersheetId'),
            id: params.id,
            questions: [],
            startedAt: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            phone: getQueryString('phone'),
            memCard: getQueryString('memCard'),
        };
        let valueList = form.getFieldsValue();
        let keyList = Object.keys(form.getFieldsValue());
        keyList.forEach(topic => {
            let option = dealOptions(topic, valueList);
            paramApi.questions.push(option);
        });
        setLoading(true);

        const res: any = await saveTrainSurveyApi(paramApi);
        setLoading(false);
        console.log('提交成功', paramApi);
        if (res && res.status_code === 200) {
            localStorage.removeItem('formData');
            localStorage.removeItem('sessionId');
            localStorage.removeItem('answersheetId');

            trainingTaskStateApi(
                {
                    resourceId: getQueryString('resourceId') || '',
                    resourceType: 10,
                    projectId: getQueryString('projectId') || '',
                    currentDuration: res?.data,
                },
                getQueryString('classToken') || '',
            );

            const channelId = localStorage.getItem('channelId');
            const empid = localStorage.getItem('empid');
            localStorage.removeItem('channelId');
            localStorage.removeItem('empid');

            // QT 埋点
            // 控件点击：医调研-问卷提交
            if ((window as any)?.aplus_queue?.push) {
                const cusp: {
                    survey_id: number;
                    survey_title: string;
                    chid?: number;
                    empid?: number;
                    source?: string;
                } = {
                    survey_id: Number(params.id),
                    survey_title: name,
                };
                if (channelId) {
                    cusp.chid = Number(channelId);
                }
                if (empid) {
                    cusp.empid = Number(empid);
                }
                if (getQueryString('source')) {
                    cusp.source = getQueryString('source') || '';
                }
                (window as any).aplus_queue.push({
                    action: 'aplus.record',
                    arguments: ['survey_click_btn_submit', 'CLK', cusp],
                });
            } else {
                console.error('aplus_queue 对象未定义');
            }

            navigate(`/s/${params.id}/result?type=1`, { replace: true });
        }
    };

    // 处理各种题型答案提交
    const dealOptions = (topic: string, valueList: any) => {
        let topicArr = topic.split('-');
        let topicId = topicArr[0];
        let topicType = topicArr[1];
        let option;
        // 单选
        if (topicType === '1') {
            option = {
                id: topicId,
                questionTypeId: topicType,
                options: [
                    {
                        answer: valueList[topic] && valueList[topic].length && valueList[topic][1] ? valueList[topic][1] : null,
                        id: valueList[topic] && valueList[topic].length ? valueList[topic][0] : '',
                    },
                ],
            };
        }
        // 判断
        if (topicType === '3') {
            option = {
                id: topicId,
                questionTypeId: topicType,
                options: [
                    {
                        answer: null,
                        id: valueList[topic],
                    },
                ],
            };
        }
        // 多选
        if (topicType === '2') {
            option = {
                id: topicId,
                questionTypeId: topicType,
                options: getAnswerOption('2', valueList[topic]),
            };
        }
        // 填空题（单项、多项）
        if (topicType === '4' || topicType === '5') {
            option = {
                id: topicId,
                questionTypeId: topicType,
                options: [
                    {
                        answer: getFillAnswer(valueList[topic]),
                        id: '',
                    },
                ],
            };
        }
        // 问答
        if (topicType === '6') {
            option = {
                id: topicId,
                questionTypeId: topicType,
                attachment: fileDeal(valueList[topic]?.file?.fileList),
                options: getAnswerOption('6', valueList[topic]),
            };
        }
        // 地区
        if (topicType === '7') {
            option = {
                id: topicId,
                questionTypeId: topicType,
                options: [
                    {
                        answer: valueList[topic] && valueList[topic].length ? valueList[topic].toString() : null,
                        id: '',
                    },
                ],
            };
        }
        return option;
    };

    // 处理填空题未作答null
    const getFillAnswer = (values: any) => {
        const isNull = values && values.length ? values.filter((it: any) => it) : [];
        if (isNull && isNull.length) {
            return JSON.stringify(values);
        }
        return null;
    };

    const fileDeal = (fileList: any) => {
        let arr: string[] = [];
        if (fileList && fileList.length) {
            fileList.forEach((file: any) => {
                if (file.url) {
                    arr.push(file.url);
                }
            });
        }
        return arr;
    };

    // 答案选项提交处理
    const getAnswerOption = (type: string, answer: any) => {
        let options: any = [];
        if (type === '6') {
            options.push({
                id: '',
                answer: answer?.text,
            });
        }
        if (type === '2') {
            if (answer && answer.length) {
                if (answer[0] && answer[0].length) {
                    answer[0].forEach((item: any) => {
                        options.push({
                            id: item,
                            answer: answer[1] ? answer[1] : null,
                        });
                    });
                }
            }
        }
        return options;
    };

    // 获取题目类型
    const getTag = (type: number) => {
        switch (type) {
            case 1:
                return '单选题';
            case 2:
                return '多选题';
            case 3:
                return '判断题';
            case 4:
                return '单项填空';
            case 5:
                return '多项填空';
            case 6:
                return '问答题';
            case 7:
                return '地区题';
            default:
                return;
        }
    };

    // 题目组件渲染
    const getTemp = (item: any, index: number) => {
        switch (item.questionTypeId) {
            case 1:
                return <Single {...item} num={index} />;
            case 2:
                return <Multiple {...item} num={index} />;
            case 3:
                return <Judge {...item} num={index} />;
            case 4:
                return <MvpFill {...item} num={index} />;
            case 5:
                return <MvpFill {...item} num={index} />;
            case 6:
                return <Answer {...item} num={index} form={form} />;
            case 7:
                return <MvpRegion {...item} num={index} form={form} />;
            default:
                return null;
        }
    };

    // 获取问卷详情
    const getSurveyDetails = async () => {
        if (!params?.id) return;
        const res: any = await surveyDetailApi({ id: params.id });
        if (res && res.status_code === 200) {
            setName(res.data.name);
            setDirections(res.data.directions);
            if (res.data.questionList && res.data.questionList.length) {
                setDataList(res.data.questionList);
            }
            getCover(res);
            setIsMount(true);
            if (res.data.status === 0 && getQueryString('type') !== '1') {
                message.error('问卷未发布，无法访问');
                navigate(`/s/${params.id}`);
                return;
            }
            if (res.data.isNeedLogin && (!getCookie('memToken') || !getCookie('authentication_member_card'))) {
                navigate(`/s/${params.id}`);
            }
        }
    };

    // 获取模板预览详情
    const getTemplateDetail = async () => {
        if (!params?.id) return;
        const res: any = await templateDetailApi({ id: params.id });
        if (res && res.status_code === 200) {
            setName(res.data.name);
            setDirections(res.data.directions);
            if (res.data.questionList && res.data.questionList.length) {
                setDataList(res.data.questionList);
            }
            getCover(res);
        }
    };

    // 设置封面图
    const getCover = (res: any) => {
        const survey: any = document.getElementsByClassName('survey-answer')[0];
        if (window.innerWidth > 750) {
            survey.style.backgroundImage = res.data.webHeaderCover ? `url(${res.data.webHeaderCover})` : '';
        } else {
            survey.style.backgroundImage = res.data.h5HeaderCover ? `url(${res.data.h5HeaderCover})` : '';
        }
        if (getQueryString('type') === '1' || getQueryString('type') === '2' || params?.sid) {
            survey.style.backgroundPosition = 'center top';
        }
    };

    // 继续作答 - 未提交答案回显
    const initFormData = () => {
        const formData = localStorage.getItem('formData');
        if (formData) {
            form.setFieldsValue(JSON.parse(formData));
        }
    };

    // 监听表单变化，本地缓存表单内容
    const onValuesChange = (a: any) => {
        if (!params?.sid && !getQueryString('type')) {
            console.log(form.getFieldsValue());
            localStorage.setItem('formData', JSON.stringify(form.getFieldsValue()));
        }
    };

    // 获取问卷详情 - 答案回显
    const getSurveyResult = async () => {
        const res: any = await surveyResultApi({ id: params.id });
        if (res && res.status_code === 200) {
            setName(res.data.name);
            setDirections(res.data.directions);
            if (res.data.questionList && res.data.questionList.length) {
                setDataList(res.data.questionList);
            }
            getCover(res);
        }
    };

    // 附件参数回显
    const getFileList = (attachment: string[]) => {
        if (attachment && attachment.length) {
            const arr = attachment.map((it: string) => ({ url: it }));
            return arr;
        }
        return [];
    };

    // 获取答案内容回显表单
    const getAnswerContent = (item: any) => {
        let answer: any;
        if (item.questionTypeId === 1) {
            answer = [];
            let arr = item.optionList && item.optionList.length && item.optionList.filter((it: any) => it.selected);
            answer[0] = arr && arr.length ? arr[0].id : '';
            answer[1] = arr && arr.length ? arr[0].exContent : '';
        }
        if (item.questionTypeId === 2) {
            let arr = item.optionList && item.optionList.length && item.optionList.filter((it: any) => it.selected);
            answer = [];
            answer[0] = [];
            if (arr && arr.length) {
                arr.forEach((el: any) => {
                    answer[0].push(el.id);
                    answer[1] = el.exContent;
                });
            }
        }
        if (item.questionTypeId === 3) {
            let arr = item.optionList && item.optionList.length && item.optionList.filter((it: any) => it.selected);
            if (arr && arr.length) {
                answer = arr[0].id;
            }
        }
        if (item.questionTypeId === 4 || item.questionTypeId === 5) {
            if (item.optionList && item.optionList.length) {
                item.optionList.forEach((el: any) => {
                    answer = el.content ? JSON.parse(el.content) : [];
                });
            }
        }
        if (item.questionTypeId === 6) {
            answer = {};
            if (item.optionList && item.optionList.length) {
                item.optionList.forEach((el: any) => {
                    answer.text = el.content;
                    answer.file = getFileList(item.attachment);
                });
            }
        }
        return answer;
    };

    // 格式化描述内容
    const formatDirections = (values?: string) => {
        if (values) {
            const arr = values.split('\n');
            return arr;
        }
        return [];
    };

    // 问卷答案回显
    useEffect(() => {
        if (params.sid && dataList && dataList.length) {
            let values: any = {};
            dataList.forEach((item: any) => {
                let key = `${item.id}-${item.questionTypeId}`;
                if (item.questionTypeId !== 7) {
                    values[key] = getAnswerContent(item);
                }
            });
            form.setFieldsValue(values);
        }
    }, [dataList]);

    // 页面初始化
    const init = async () => {
        const res: any = await surveyInfoApi({ id: params?.id });
        if (res.status_code === 200) {
            localStorage.setItem('sessionId', res?.data?.sessionId);
            const resBegin: any = await beginAnswerApi({
                surveyId: params?.id,
                projectId: getQueryString('projectId') || '',
                resource: getQueryString('projectId') ? 'JXY' : undefined,
            });
            if (resBegin && resBegin.status_code === 200) {
                localStorage.setItem('answersheetId', resBegin?.data?.id);
                getSurveyDetails();
                initFormData();
            }
        }
    };

    useEffect(() => {
        if (params.sid && params.id) {
            getSurveyResult();
        } else {
            init();
        }
    }, []);

    return (
        <>
            <div className="survey-answer">
                <div className="survey-content" style={{ margin: '0 auto' }}>
                    <p className="title">{name}</p>
                    <div className="description">
                        {formatDirections(directions) && formatDirections(directions).length
                            ? formatDirections(directions).map((item, index) => {
                                  return (
                                      <Fragment key={index}>
                                          <p style={{ textIndent: '2em', marginBottom: '.5em' }} dangerouslySetInnerHTML={{ __html: item }}></p>
                                      </Fragment>
                                  );
                              })
                            : null}
                    </div>
                    <div className="examination">
                        <Form form={form} layout="vertical" autoComplete="off" onValuesChange={onValuesChange}>
                            {dataList && dataList.length
                                ? dataList.map((item: any, index) => (
                                      <div className="examination-item" key={index}>
                                          <p className="examination-tag">{getTag(item.questionTypeId)}</p>
                                          {getTemp(item, index + 1)}
                                      </div>
                                  ))
                                : null}
                        </Form>
                    </div>
                    {isMount && !params?.sid && !getQueryString('type') ? (
                        <div className="sumit">
                            <Spin spinning={loading}>
                                <Button type="primary" block onClick={sumit}>
                                    提交
                                </Button>
                            </Spin>
                        </div>
                    ) : null}
                </div>
            </div>
        </>
    );
};

export default SurveyAnswerMvp;
